exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fancy-example__accordion___3Qpd6{border:1px solid rgba(0,0,0,.1);border-radius:2px}.fancy-example__accordion__item___3FtqI+.fancy-example__accordion__item___3FtqI{border-top:1px solid rgba(0,0,0,.1)}.fancy-example__accordion__button___dHlS3{background-color:#f4f4f4;color:#444;cursor:pointer;padding:18px;width:100%;text-align:left;border:none}.fancy-example__accordion__button___dHlS3:hover{background-color:#ddd}.fancy-example__accordion__button___dHlS3:before{display:inline-block;content:\"\";height:10px;width:10px;margin-right:12px;border-bottom:2px solid currentColor;border-right:2px solid currentColor;transform:rotate(-45deg)}.fancy-example__accordion__button___dHlS3[aria-expanded=true]:before,.fancy-example__accordion__button___dHlS3[aria-selected=true]:before{transform:rotate(45deg)}.fancy-example__accordion__panel___3U3wv{padding:20px;animation:fancy-example__fadein___236lT .35s ease-in}@keyframes fancy-example__fadein___236lT{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"accordion": "fancy-example__accordion___3Qpd6",
	"accordion__item": "fancy-example__accordion__item___3FtqI",
	"accordion__button": "fancy-example__accordion__button___dHlS3",
	"accordion__panel": "fancy-example__accordion__panel___3U3wv",
	"fadein": "fancy-example__fadein___236lT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/react-accessible-accordion/dist/fancy-example.css
// module id = kRGM
// module chunks = 0